import { render, staticRenderFns } from "./foro.vue?vue&type=template&id=9b071b70&scoped=true"
import script from "./foro.vue?vue&type=script&lang=js"
export * from "./foro.vue?vue&type=script&lang=js"
import style0 from "./foro.vue?vue&type=style&index=0&id=9b071b70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b071b70",
  null
  
)

export default component.exports